var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28906 21.3984C8.66927 20.0234 11.9062 19.3359 15 19.3359C18.0938 19.3359 21.3021 20.0234 24.625 21.3984C28.0052 22.7161 29.6953 24.4635 29.6953 26.6406V30.3359H0.304688V26.6406C0.304688 24.4635 1.96615 22.7161 5.28906 21.3984ZM20.1562 13.4922C18.724 14.9245 17.0052 15.6406 15 15.6406C12.9948 15.6406 11.276 14.9245 9.84375 13.4922C8.41146 12.0599 7.69531 10.3411 7.69531 8.33594C7.69531 6.33073 8.41146 4.61198 9.84375 3.17969C11.276 1.6901 12.9948 0.945312 15 0.945312C17.0052 0.945312 18.724 1.6901 20.1562 3.17969C21.5885 4.61198 22.3047 6.33073 22.3047 8.33594C22.3047 10.3411 21.5885 12.0599 20.1562 13.4922Z",
    fill: "#CE3C25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.964b5cd017536a2c4fedb4b0b65d27ff.svg";
export { ForwardRef as ReactComponent };